import { render, staticRenderFns } from "./pay-dialog-iframe.vue?vue&type=template&id=0f958282&scoped=true&"
import script from "./pay-dialog-iframe.vue?vue&type=script&lang=js&"
export * from "./pay-dialog-iframe.vue?vue&type=script&lang=js&"
import style0 from "./pay-dialog-iframe.vue?vue&type=style&index=0&id=0f958282&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f958282",
  null
  
)

export default component.exports